import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from './Context'
import { Alert, ShowIf } from '@ztechapps/webui.util'

export const ErrorDisplay = () => {
  const { errorMessage } = useContext()
  return (
    <ShowIf condition={!isEmpty(errorMessage)}>
      <Alert>
        <div>{errorMessage}</div>
      </Alert>
    </ShowIf>
  )
}
